// extracted by mini-css-extract-plugin
module.exports = {"container":"container--RlrEk","tip1":"tip1--WfLaa","tip2":"tip2--HhZt3","emptyImg":"emptyImg--EQeTg","btn":"btn--KoNKH"};